export default __webpack_public_path__ + "static/media/mayaicon_dark.e6505185.svg";